import { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import MenuIcon from '@mui/icons-material/Menu'
import SettingsIcon from '@mui/icons-material/Settings'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Popover from '@mui/material/Popover'
import useMediaQuery from '@mui/material/useMediaQuery'

import AccountMenu from 'components/Account/Menu'
import AdminMenu from 'components/Admin/Menu'
import { useAccount } from 'hooks/useAccount'
import useAuth, { signOut } from 'lib/auth'

export default function NavBar() {
  const { user, isAdmin } = useAuth()
  const { accounts, clearAccounts } = useAccount()
  const [menuOpen, setMenuOpen] = useState(false)
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(null)
  const match = useRouteMatch('/accounts/:id')
  const accountId = Boolean(match) ? match.params.id : null
  const isXS = useMediaQuery(({ breakpoints }) => breakpoints.only('xs'))
  const isAdminPage = Boolean(useRouteMatch('/admin'))

  useEffect(() => {
    if (!isXS && menuOpen) {
      setMenuOpen(false)
    }
  }, [isXS, menuOpen])

  const handleSignOut = () => {
    signOut().then(() => {
      clearAccounts()
      history.push('/login')
      setAnchorEl(null)
    })
  }

  const handleClickSettings = () => {
    history.push('/user/edit')
    setAnchorEl(null)
  }

  const handleClickAccount = id => {
    history.push(`/accounts/${id}`)
    setAnchorEl(null)
  }

  const handleClickManual = () => {
    window.open('/manual.pdf', '_blank')
    setAnchorEl(null)
  }

  const handleClickInquiry = () => {
    const subject = 'タイムリーリミットに関するお問い合わせ'
    window.location.href = `mailto:res9@e-sanwa.jp?subject=${subject}`
    setAnchorEl(null)
  }

  const handleClickAdmin = () => {
    history.push('/admin')
    setAnchorEl(null)
  }

  const handleClickAccountNew = () => {
    history.push('/accounts/new')
    setAnchorEl(null)
  }

  const account = (accounts && accounts.find(x => x.id === accountId)) || null

  return (
    <>
      <div
        style={{
          height: 40,
          background: 'url(/header-pattern.png) repeat-x',
          backgroundSize: '2px 40px',
          position: 'sticky',
          display: 'flex',
          top: 0,
          zIndex: 10,
        }}
      >
        {isXS && (account || isAdminPage) && (
          <IconButton onClick={() => setMenuOpen(true)} sx={{ p: 1 }}>
            <MenuIcon />
          </IconButton>
        )}
        <Box sx={{ ml: 1 }}>
          <img src="/logo.png" style={{ height: 52 }} alt="logo" />
        </Box>
        <div style={{ flexGrow: 1 }} />
        {user && (
          <IconButton onClick={event => setAnchorEl(event.currentTarget)} sx={{ p: 1 }}>
            <SettingsIcon />
          </IconButton>
        )}
      </div>
      {user && (
        <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <List>
            {Boolean(user.displayName) && (
              <>
                <ListItem>
                  <ListItemText
                    primary={
                      <span style={{ fontWeight: 'bold' }}>{user.displayName.slice(0, 20)}</span>
                    }
                  />
                </ListItem>
                <Divider />
              </>
            )}
            {isAdmin && (
              <>
                <ListItem button onClick={handleClickAdmin} disabled={isAdminPage}>
                  <ListItemText primary="管理画面" />
                </ListItem>
                <Divider />
              </>
            )}
            {(accounts || []).map(x => (
              <ListItem
                key={x.id}
                button
                onClick={() => handleClickAccount(x.id)}
                disabled={x.id === accountId}
              >
                <ListItemText primary={x.name} />
              </ListItem>
            ))}
            <ListItem button onClick={handleClickAccountNew}>
              <ListItemText primary="アカウント追加" />
            </ListItem>
            <Divider />
            <ListItem button onClick={() => handleClickSettings()}>
              <ListItemText primary="ユーザー名変更" />
            </ListItem>
            <ListItem button onClick={() => handleClickManual()}>
              <ListItemText primary="操作マニュアル" />
            </ListItem>
            <ListItem button onClick={() => handleClickInquiry()}>
              <ListItemText primary="お問い合わせ" />
            </ListItem>
            <Divider />
            <ListItem button onClick={handleSignOut}>
              <ListItemText primary="ログアウト" />
            </ListItem>
          </List>
        </Popover>
      )}
      {account && (
        <Drawer anchor="left" open={menuOpen} onClose={() => setMenuOpen(false)}>
          <AccountMenu account={account} onClick={() => setMenuOpen(false)} drawer />
        </Drawer>
      )}
      {isAdminPage && (
        <Drawer anchor="left" open={menuOpen} onClose={() => setMenuOpen(false)}>
          <AdminMenu onClick={() => setMenuOpen(false)} drawer />
        </Drawer>
      )}
    </>
  )
}
